var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.chartOptions)?_c('ApexChart',{staticClass:"mt-5",attrs:{"element":"bunkerSummaryChart","chartOption":_vm.chartOptions,"series":_vm.chartOptions.series}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }